  function cm_popup_win_pos(url,x,y,w,h,param) {
  
    sw = screen.width ;
    sh = screen.height ;
    
    if (param == "") {
      param="status=yes,resizable=yes,scrollbars=yes,status=no,menubar=no,location=no" ;
    }
    
    /*if (sw > 800) {
      w = 800 ;
    }                   
    if (sh > 600) {
      h = 600 ;
    }*/
  
     if (x == 0) {
       x = Math.round((sw-w) / 2) ;  
     }
     
     if (y == 0) {
       y = Math.round((sh-h) / 2) ; 
     }
     
    document.mywin=window.open (url,"mywin",
      'width='+w+',height='+h+',left='+x+',top='+y+','+ param
    ) ;
    // ra / 11.2.2010 - Problem im ie gab eine Fehlermeldung - Permission denied
    // document.mywin.parent_window=document ;
    document.mywin.focus() ;
    document.body.onunload = unload_window ;
  }

  function cm_popup_win(url,w,h,param) {
    cm_popup_win_pos(url,0,0,w,h,param) ;
  }

  function unload_window() {
    if (document.mywin) {
      document.mywin.close() ;
    }
  }
  
function get_url(ahref) {
  if (ahref.indexOf("?") == -1) {
    return ahref ;
  } else {
    var t = ahref.split("?") ;
    return t[0] ;
  }
}

function add_param(ahref,name,value) {
  var s = ahref ;
  if (s.indexOf("?") == -1) {
    s=s + "?" + name + "=" + escape(value) ;
  } else if (s.indexOf(name) >= 0) {

    var i=0 ;
    var b="" ;
    var t = s.split("?") ;
    var a=t[1].split("&") ;
    s = t[0] + "?" ;
    for (i=0 ; i< a.length ; i++) {
      b=a[i].split("=") ;
      if (i > 0) {
        s = s + "&" ;
      }
      if (b[0] == name) {
        s = s + name + "=" + value ;
      } else {
        s = s + b[0] + "=" + b[1] ;
      }
    }
  } else {
    s=s + "&" + name + "=" + escape(value) ;
  }
  return s ;
}

function cms_open_window(href,title) {
  window.open(href,title,"toolbar=yes,location=no,directories=no,,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=700,height=550,status=0") ;
}

function cms_open_printablepage() {	 
  var page=document.location.href ;
  //page=page + "cms_show_printable=1" ;
  page=add_param(page,"cms_show_printable","1") ;
  window.open(page,"printable","toolbar=yes,location=no,directories=no,,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=700,height=550,status=0") ;
}      

/* Rolf */
function cms_open_mailablepage(alternative) {

  var page=document.location.href ;
  
  if (typeof alternative !== 'undefined' && alternative != ""){
    page=alternative;
  }
  var href=page ;

  page=add_param(page,"href",href) ;
  page=add_param(page,"cmsaction","mailable") ;
  // page=page + "cmsaction=mailable&href=" + escape(href) ;
  window.open(page,"mailable","toolbar=yes,location=no,directories=no,,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=700,height=550,status=0") ;
}      

function cms_open_adr_contact(adrid) {
  var page=document.location.href ;

  /*
  page=add_param(page,"adrid",adrid) ;
  page=add_param(page,"cmsaction","adr_contact") ;
  */
  page = get_url(document.location.href) ;
  //tracking-codes in URL entfernen
	page = page.split('##')[0];
  page=page + "?cmsaction=adr_contact&adrid="+adrid ;
  window.open(page,"contact","toolbar=yes,location=no,directories=no,,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=700,height=550,status=0") ;
}

	function comments(commid) {
	 var page="contact.cfm" ;
  	var href=page ;

   
   page=page + "?cmsaction=comm_contact&cid="+commid ;

  window.open(page,"contact","toolbar=no,location=no,directories=no,,status=yes,menubar=no,scrollbars=yes,resizable=yes,width=700,height=550,status=0") ;

  
  };
